'use strict';

export default function($stateProvider, $urlRouterProvider) {
  'ngInject';

  $urlRouterProvider.when("/betagroups", "/betagroups/list");
  $stateProvider
    .state('betagroups', {
      url: '/betagroups',
      template: require('./betagroups.html'),
      authenticate: true
    })
    .state('betagroups.list', {
      url: '/list',
      template: require('./list/list.html'),
      controller: 'BetaGroupsListController',
      controllerAs: 'betagroupsListCtrl'
    })
    .state('betagroups.edit', {
      url: '/edit/:id',
      template: require('./edit/edit.html'),
      controller: 'BetaGroupsEditController',
      controllerAs: 'betagroupsEditCtrl'
    })
    .state('betagroups.add', {
      url: '/add',
      template: require('./add/add.html'),
      controller: 'BetaGroupsAddController',
      controllerAs: 'betagroupsAddCtrl'
    })
    .state('betagroups.show', {
      url: '/show/:id',
      template: require('./show/show.html'),
      controller: 'BetaGroupsShowController',
      controllerAs: 'betagroupsShowCtrl'
    })
    .state('betagroups.adduser', {
      url: '/:id/adduser',
      template: require('./adduser/adduser.html'),
      controller: 'BetaGroupsAddUserController',
      controllerAs: 'betagroupsAddUserCtrl'
    })
    .state('betagroups.import', {
      url: '/:id/import',
      template: require('./import/import.html'),
      controller: 'BetaGroupsImportController',
      controllerAs: 'betagroupsImportCtrl'
    });
}



// WEBPACK FOOTER //
// ./client/app/betagroups/betagroups.routes.js